// VideoCard.jsx
import React from "react";
import { Card, Chip, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { VideoThumbnail } from "./VideoThumbnail";

export const VideoCard = ({ video, onClick }) => {
  const thumbnailSrc = video?.thumbnail || video?.thumbnailFileUrl;
  const durationLabel =
    video?.duration ||
    (typeof video?.durationInSeconds === "number"
      ? `${String(Math.floor(video.durationInSeconds / 60)).padStart(2, "0")}:${String(
          video.durationInSeconds % 60
        ).padStart(2, "0")}`
      : "00:00");

  return (
    <Card
      onClick={onClick}
      sx={{
        cursor: "pointer",
        padding: "5px 10px",
        mt:1,
        paddingTop: "0px",
        boxShadow: "none",
        borderRadius: "4px",
        backgroundColor: "lightgray"
      }}>
      <Stack sx={{ gap: 0.5 }} direction="row" >
        <div style={{ position: "relative" }}>
          <VideoThumbnail src={thumbnailSrc} alt="video thumbnail" width="120px" height="70px" />
          <Chip
            sx={{
              backgroundColor: "black",
              color: "white",
              borderRadius: "5px",
              position: "absolute",
              bottom: "10px",
              right: "10px"
            }}
            size="small"
            label={durationLabel}
          />
        </div>
        <Stack  sx={{ gap: 1, p: 1 }}>
          <Typography sx={{ fontWeight: "bold" }} variant="h5">
            {video.title}
          </Typography>
          <Typography sx={{ color: "grey" }} variant="body2">
            {dayjs(video.dateCreated).format("MMMM DD, YY")}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

